const LEGACY_COOKIE = 'prof_profileid';

export function cleanupDeprecatedKeys(): void {
    localStorage.removeItem(LEGACY_COOKIE);
}